<template>
  <div class="map-editor">
    <MapNav class="map-editor__nav" @mapNavHandle="mapNavHandle" />
    <div class="map-editor__content">
      <transition name="fade" mode="out-in" appear>
        <keep-alive>
          <router-view v-if="this.$route.meta.keepAlive"/>
        </keep-alive>
      </transition>
      <transition name="fade" mode="out-in" appear>
        <router-view v-if="!this.$route.meta.keepAlive"/>
      </transition>
    </div>
  </div>
</template>

<script>
import MapNav from '@/components/editor/map-nav.vue';

export default {
  components: {
    MapNav
  },
  methods: {
    mapNavHandle(route) {
      this.$router.push(route);
    }
  }
};
</script>

<style scoped lang="scss">
  .map-editor {
    width: 100%;
    display: flex;
    overflow-y: hidden;

    &__content {
      flex: 1;
      width: calc(100% - 150px);
      overflow-y: scroll;
    }
  }
</style>
